enum CampaignSearchParamKey {
  Status = 'status',
  Type = 'type',
  Date = 'date',
  Timezone = 'timezone',
}

export {CampaignSearchParamKey};